import * as types from '../actions/types';

const initialState = {
   toggler:false
}

export default function SidebarReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.TOGLLE_SIDEBAR:
            return {
                
                toggler:action.payload,
            } 
        default:
            return state
    }
}
